import { useQuery } from '@tanstack/react-query';
import { boatsService } from '../services/boats/boatsService';
import type { BoatRosterEntryWithRower } from '../types/boats';

/**
 * Hook to get boat roster with rower details
 * @param boatId Boat ID
 * @param enabled Whether the query should run
 */
export function useBoatRoster(boatId: string | null, enabled = true) {
  return useQuery({
    queryKey: ['boat-roster', boatId],
    queryFn: async (): Promise<BoatRosterEntryWithRower[]> => {
      if (!boatId) return [];
      const { data, error } = await boatsService.getBoatRosterWithRowers(boatId);
      if (error) throw error;
      return data || [];
    },
    enabled: enabled && !!boatId,
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
}
